// import { configDotenv } from "dotenv";
// import 'dotenv/config'
// console.log(configDotenv)
// require('dotenv').config({ path: '.env' });
// console.log(process);

// ---существующие события для privateUser.${user?.id}:
// newMessageInDialog - новое сообщение
// changeMessageInDialog - редактирование сообщения
// deleteMessageInDialog - удаление сообщения
// newChatDialog - добавление нового чата
// removeChatDialog - удаление чата
// changePublicUnreadMessages - изменение непрочитанных сообщений
// changePublicCountActiveApprovals - изменение кол-ва активных согласований
// changeStatusPublicOrder - изменение статуса заявки
// updatePublicOrder - изменение заявки
// createPublicOrder - создание новой заявки
// deleteOrder - удаление заявки
// deletePublicOrder - удаление заявки
// updatePublicTOHolder - обновление оборудования
// updateStatusPublicTOHolder - обновление статуса оборудования
// deletePublicTOHolder - удаление оборудования

// ---существующие события для articlesPublic.${id}
// updateArticlePublic - обновление самой статьи

// ---существующие события для articlesPublic
// changeNameArticlePublic - изменение имени статьи

// ---существующие события для articles
// updateTable - удаление статьи. Название тянется еще с админки

// ---существующие события для chats.${chatID}
// sendMassageFromChanel
// client-addMessage

// ---существующие события для publicOrder.${id}
// publicOrderUpdateApproves - обновление согласования

export const IS_DEV = process.env.NODE_ENV === "development"
export const DEFAULT_LANGUAGE = process.env.REACT_APP_PUBLIC_DEFAULT_LANGUAGE || "ru"
export const LANGUAGES = process.env.REACT_APP_PUBLIC_LANGUAGES ? process.env.REACT_APP_PUBLIC_LANGUAGES.split(",") : []
export const PAGE_TITLE = process.env.REACT_APP_PUBLIC_PAGE_TITLE || "Staq"
export const OG_TITLE = process.env.REACT_APP_PUBLIC_OG_TITLE || "Личный кабинет клиента"
export const DEFAULT_COUNTRY_CODE: any = process.env.REACT_APP_PUBLIC_DEFAULT_COUNTRY_CODE ?? "RU"
export const OG_DESCRIPTION =
  process.env.REACT_APP_PUBLIC_OG_DESCRIPTION ||
  "Инновационный каталог услуг для вашего бизнеса и взаимодействия с контрагентами"
export const PAGE_IMG = process.env.REACT_APP_PUBLIC_OG_IMG || "/img/og.png"
export const EMAIL_REGEXP =
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i
export const PASS_REGEXP = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+~()^?`-])[A-Za-z\d@$!%*#?&+~()^?`-]{8,}$/
export const LINK_REGEXP =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/

// export const BACKEND_HOST = process.env.NEXT_PUBLIC_BACKEND_HOST
// export const USER_ID_COOKIE = 'user_id'
export const USER_TOKEN_COOKIE = "tokenServices"
export const USER_TOKEN_EXPIR = "tokenExpirService"
export const USER_REFRESH_TOKEN_SEND = "rTokenSendService"
export const USER_ID_COOKIE = "userID"
export const USER_OBJECT_COOKIE = "userObjLK"
export const SELECTED_QR_CAMERA = "userQrCamera"
export const MENU_LIST_COOKIE = "listMenu"
export const STAQ_VERSION_COOKIE = "staqVLk"
export const SAVED_SERVICE_COOKIE = "savedService"
export const HAS_USER_OBJECT_COOKIE = "hasUserObject"
export const SESSION_ONE_PROJECT_VISITED = "isOneProjectVisited"
export const CSRF_TOKEN = "XSRF-TOKEN"
export const MAX_AGE_TOKEN_180_DAYS_IN_SECONDS = 60 * 60 * 24 * 30 * 6 //30 дней
export const LIMIT_CHATS_COUNT = 14
export const videoFormats = ["mp4", "3gp", "wmv", "mpeg", "flv", "webm", "avi", "mkv", "3gpp", "mpg", "m4v"]
export const LANG_LIST = [
  {
    text: "English",
    value: "en",
  },
  // {
  //   text: "ภาษาไทย",
  //   value: "th",
  // },
  // {
  //   text: "China",
  //   value: "cn",
  // },
  // {
  //   text: "Français",
  //   value: "fr",
  // },
  {
    text: "Русский",
    value: "ru",
  },
]

export const monthArr: any = {
  ru: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ],
  en: [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ],
  th: [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ],
}

export const EMPTY_LAST_MESSAGE = {
  chat_dialog_id: "",
  id: "",
  text: "",
  user: {
    addPhoneNumber: null,
    avatar_id: null,
    company_id: "",
    departmentName: "",
    email: "",
    externalId: null,
    folderName: "",
    folder_id: null,
    id: "",
    isAdmin: false,
    is_blocked: false,
    lastLogin: "",
    login: "",
    name: "",
    phoneNumber: "",
    position: "",
    roles: [],
    skills: [],
    work_schedule_id: null,
  },
  with_photos: false,
  with_attachments: false,
  created_at: 0,
  is_readed: true,
  readed_at: null,
  attachments: [],
  attachments_info: [],
  photos: [],
  photos_info: [],
  reply_id: null,
}

export const PATTER_SPAN_DATA_USER_ID = /(<span data-userid=.*?>(.*?)<\/span>)/gi
